import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router";
import {Helmet} from "react-helmet";
import BlockUi from "@availity/block-ui";
import GroupForm from "../../components/GroupForm";
import axios from "../../../../helpers/axios";
import {useParams} from "react-router-dom";
import {RacoonGroupListRoute} from "../../../routesConstants";
import {Tab, Tabs} from "react-bootstrap";
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import ReviseGroupPage from "./revise";

const EditGroup = () => {
  const {id} = useParams();
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState()
  const navigate = useNavigate()
  const [tabIndex, setTabIndex] = useState(window.location.hash?.slice(1) ||"settings");
  const [problems, setProblems] = useState()

  const loadInfo = () =>{
    setLoading(true)
    axios.get('/api/racoon/revise/group/'+id)
      .then(({data})=>{
        console.log('edit', data)
        setData(data.group)
      })
      .finally(()=>setLoading(false))
    axios.post('/api/racoon/revise/group/validate/'+id)
      .then(({data})=>{
        console.log('validate', data)
        setProblems(data.sheetValidation)
      })
  }
  useEffect(() => {
    loadInfo()
  }, []);

  const onSubmit = (data) =>{
    setLoading(true)
    axios.patch('/api/racoon/revise/group/'+id, data)
      .then(()=>{
        loadInfo()
      })
      .finally(()=>setLoading(false))
  }

  const removeGroup = () =>{
    if(window.confirm('Вы уверены, что хотите удалить ' +data?.name+'?')){
      axios.delete('/api/racoon/revise/group/'+id)
        .then(()=>navigate(RacoonGroupListRoute))
        .finally(()=>setLoading(false))
    }
  }

  const fixGroup = (cb) =>{
    setLoading(true)
    axios.post('/api/racoon/revise/group/fix/'+id)
      .then(({data})=>{
        console.log('fix', data)
        setProblems(p=>({...p, notInGoogle: []}))
        cb()
      })
      .finally(()=>setLoading(false))
  }
  return (
    <>
      <Helmet><title>Редактирование {data ? data.name : 'группы'}</title></Helmet>
      <Tabs
        variant="underline"
        id="controlled-tab-example"
        activeKey={tabIndex}
        onSelect={key => {
          setTabIndex(key)
          window.location.hash = key
        }}
      >
        <Tab eventKey="settings" title="Настройки" >
          <BlockUi blocking={loading}>
            {data && <GroupForm data={data}
                                cb={onSubmit}
                                problems={problems}
                                fix={fixGroup}
                                edit
                                removeGroup={removeGroup}/>}
          </BlockUi>
        </Tab>
        <Tab eventKey="racoon" title="Сверка" >
          {data &&
              <ReviseGroupPage options={{id,
                startDate: data.startDate,
                endDate: data.endDate}}/>
          }
        </Tab>
      </Tabs>
    </>
  );
};

export default EditGroup;
